import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Box, Typography, Paper, Button, Container } from "@mui/material";
import { colors } from "../theme";
import { useDbUser } from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import Loading from "../components/Loading";

const Waitlist = () => {
  const { user, logout } = useAuth0();
  const { dbUser, isLoading } = useDbUser();
  const navigate = useNavigate();

  // Redirect to dashboard if user is already invited
  useEffect(() => {
    if (!isLoading && dbUser && dbUser.invited) {
      navigate("/dashboard", { replace: true });
    }
  }, [dbUser, isLoading, navigate]);

  // Handle user logout with redirect to home
  const logoutWithRedirect = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  // Show loading state or waitlist content based on loading status
  if (isLoading) {
    return <Loading />;
  }

  // If not loading and we reached this point, show waitlist UI
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: colors.background,
        color: colors.text.primary,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={3}
          sx={{
            p: 5,
            textAlign: "center",
            backgroundColor: colors.navbar,
            borderRadius: 2,
            border: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          <Typography variant="h4" gutterBottom fontWeight="bold">
            You're on the Waitlist!
          </Typography>

          <Box sx={{ mt: 2, mb: 4 }}>
            <Typography variant="body1" paragraph>
              Hi {user?.name}, thanks for your interest in GAZZ.IO!
            </Typography>
            <Typography variant="body1" paragraph>
              Your account has been created, but you're currently on our
              waitlist. We're rolling out access gradually to ensure the best
              experience for everyone.
            </Typography>
            <Typography variant="body1" paragraph>
              We'll notify you at <strong>{user?.email}</strong> when you've
              been invited to access the platform.
            </Typography>
          </Box>

          <Button
            variant="outlined"
            onClick={logoutWithRedirect}
            sx={{
              mt: 2,
              color: colors.text.primary,
              borderColor: `${colors.text.primary}60`,
              "&:hover": {
                borderColor: colors.primary,
                backgroundColor: `rgba(87, 49, 255, 0.1)`,
              },
            }}
          >
            Sign Out
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default Waitlist;
